import { definedNotNull } from '@df/common';
import { z, core } from 'zod';

// These two are needed here if D is of type string | number
String.prototype.stringId = String.prototype.toString;
Number.prototype.stringId = Number.prototype.toString;

Object.defineProperty(Array.prototype, 'filterMap', {
  enumerable: false,
  writable: true,
  configurable: true,
  // @ts-expect-error filter can be any
  value: function (filter) {
    const r = [];

    for (let i = 0; i < this.length; i++) {
      const item = filter(this[i], i, this);

      if (definedNotNull(item)) {
        r.push(item);
      }
    }

    return r;
  },
});

// Zod type augmentation
declare module 'zod' {
  interface ZodType<
    out Output = unknown,
    out Input = unknown,
    out Internals extends core.$ZodTypeInternals<Output, Input> = core.$ZodTypeInternals<
      Output,
      Input
    >,
  > extends core.$ZodType<Output, Input, Internals> {
    /**
     * Shorthand for: this.transform(v => v as unknown).pipe(schema)
     *
     * Useful when the intermediate output type is too specific to pipe into `schema`.
     */
    pipeUnknown<T extends z.ZodTypeAny>(this: this, schema: T): z.ZodPipe<this, T>;
    /**
     * implements `isOptional` from Zod V3.
     */
    isOptional(this: this): boolean;
  }
}

z.ZodType.prototype.pipeUnknown = function (this: z.ZodTypeAny, schema: z.ZodTypeAny) {
  // transform doesn't change runtime value; it only widens the output type to unknown
  return this.transform((value) => value as unknown).pipe(schema);
};

z.ZodType.prototype.isOptional = function (this: z.ZodTypeAny) {
  return this.safeParse(undefined).success;
};

export {};
